import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';
import _default from '../../themes/default';

export const Nav = styled.div`
    background-color: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(16px);
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;
    border-bottom: 1px solid #ece9f2;
    box-shadow: 0 8px 24px rgba(22, 22, 29, 0.04);
`;
export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  z-index: 1;
  width: min(1440px, 100%);
  padding: 0 48px;
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
  @media (max-width: 640px) {
    padding: 0 16px;
  }
  gap: 12px;
`;

export const NavLogo = styled(LinkR)`
    width: auto;
    flex-shrink: 0;
    padding: 0 6px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-decoration: none;
    color: ${({ theme }) => theme.text_primary};
    min-width: 0;
`;

export const Avatar = styled.span`
  width: 42px;
  height: 42px;
  min-width: 42px;
  margin-right: 10px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px #6d28d9;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 18%;
    transform: scale(1.65);
    display: block;
  }
`;
export const Span = styled.div`
    padding: 0 4px;
    font-weight: bold;
    font-size: 18px;
    white-space: nowrap;
`;
export const NavItems = styled.nav`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 22px;
    padding: 0 6px;
    flex: 1;

    a {
      color: ${({ theme }) => theme.text_primary};
      font-weight: 500;
      text-decoration: none;
      white-space: nowrap;
    }

    a:hover,
    a.active {
      color: ${({ theme }) => theme.primary};
    }

    @media screen and (max-width: 1024px) {
      display: none;
    }
`;


export const GitHubButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;
    :hover {
      background: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.white};     
    }
    @media screen and (max-width: 768px) { 
    font-size: 14px;
    }
`;

export const ButtonContainer = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 6px;
  flex-shrink: 0;
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;


export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 1024px) {
    display: block;
    margin-left: auto;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.text_primary};

    button {
      background: transparent;
      border: 0;
      color: inherit;
      font-size: 1.4rem;
      min-width: 44px;
      min-height: 44px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`

export const MobileMenu = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    position: absolute;
    top: 80px;
    right: 0;
    left: 0;
    width: 100%;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    padding: 8px 20px 20px;
    background: #ffffff;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
    z-index: 1000;
`

export const MobileMenuItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  list-style: none;
  width: 100%;
  height: 100%;
`

export const MobileMenuLink = styled(LinkR)`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }

  &.active {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;

export const MobileMenuButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }
`;

export  const MobileLink = styled(LinkR)`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  min-height: 44px;
  display: flex;
  align-items: center;
  :hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const MobileNavLogo = styled(LinkR)`
  width: 80%;
  padding: 0 6px;
  display: flex;
  justify-content: start;
  align-items: center;
  text-decoration: none;
  @media (max-width: 640px) {
    padding: 0 0px;
  }
`;